const chartAreaBorder = {
    id: 'chartAreaBorder',
    afterDatasetDraw(chart, _, opts) {
        const {ctx, chartArea: {top, left, width}} = chart;
        ctx.save();
        ctx.strokeStyle = opts.color;
        ctx.lineWidth = 4;
        ctx.strokeRect(left + 2, top + 1, width, 0);
        ctx.restore();
    }
}

export default chartAreaBorder